<template>
  <div class="p-6 flex-grow-1 container-p-y" id="bandwidth">
    <div
      v-if="
        hasPrivilege('settings_bandwidth_control') &&
          this.$store.getters.settings.license.active
      "
      class="row g-6"
    >
      <!-- <div class="text-center">
        <div class="mb-2">{{ $t("bandwidth.title") }}</div>
      </div> -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row row-bordered">
              <div class="col-md mb-md-0 mb-5 text-center">
                <div class="card-header pb-0">
                  {{ $t("bandwidth.total_peak") }}:
                </div>
                <span
                  class="badge bg-label-primary mt-2"
                  style="font-size: medium !important;"
                  >{{ formatSpeed(total_peak) }}</span
                >
              </div>
              <div class="col-md text-center">
                <div class="card-header pb-0">
                  {{ $t("bandwidth.total_average") }}:
                </div>
                <span
                  class="badge bg-label-info mt-2"
                  style="font-size: medium !important;"
                  >{{ formatSpeed(total_peak / 2) }}</span
                >
              </div>
            </div>
          </div>
          <div class="card-header text-center">
            {{ $t("bandwidth.total_use") }}
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md d-flex align-items-center">
                <div class="m-0">10%</div>
                <input
                  type="range"
                  v-model="total_use_percent"
                  @input="
                    updateAll();
                    validate();
                  "
                  min="0"
                  max="200"
                  value="100"
                  class="slider-range"
                />
                <div class="m-0">200%</div>
              </div>
              <div class="text-center">
                <span
                  class="badge bg-label-primary mt-5 mb-5"
                  style="font-size: medium !important;"
                  >{{ total_use_percent }}%</span
                >
              </div>
              <div
                class="d-flex align-items-center justify-content-center flex-column flex-md-row pe-5 gap-2 gap-md-4 "
              >
                <button
                  type="button"
                  @click.prevent="
                    total_use_percent = 100;
                    updateAll();
                  "
                  class="btn btn-lg btn-secondary"
                >
                  <span class="ti-xs ti ti-restore me-2"></span
                  >{{ $t("bandwidth.reset") }}
                </button>
                <button
                  @click.prevent="store()"
                  type="button"
                  class="btn btn-lg btn-primary"
                >
                  <span class="ti-xs ti ti-progress-check me-2"></span
                  >{{ $t("bandwidth.update") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-for="(profile, index) in profiles"
        :key="profile.id"
        class="col-xl-4 col-12"
      >
        <div class="card">
          <div class="card-header text-center">{{ profile.name }}</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md d-flex align-items-center">
                <div class="m-0">10%</div>
                <input
                  type="range"
                  v-model="profile.use_percent"
                  @input="
                    total_use_percent = 100;
                    validate();
                  "
                  min="0"
                  max="200"
                  value="100"
                  class="slider-range"
                />
                <div class="m-0">200%</div>
              </div>
              <div
                class="d-flex align-items-center justify-content-center  flex-md-row pe-5 gap-2 gap-md-4"
              >
                <span
                  v-if="!profile.edit"
                  @click="profile.edit = 1"
                  class="badge bg-label-primary mb-5 mt-5"
                  style="font-size: medium !important;"
                  >{{ profile.use_percent }}%</span
                >
                <input
                  type="number"
                  v-if="profile.edit"
                  v-model="profile.use_percent"
                  min="1"
                />
                <span
                  class="badge bg-label-info mt-5 mb-5"
                  style="font-size: medium !important;"
                  >{{
                    formatSpeed(
                      profile.download_rate_kb * (profile.use_percent / 100),
                    )
                  }}</span
                >
              </div>
            </div>
            <div class="row row-bordered">
              <div
                class="col-md mb-md-0 mb-5 text-center flex flex-col justify-between align-items-center"
              >
                <div class="card-header pb-0">
                  {{ $t("bandwidth.online_accounts") }}:
                </div>
                <span
                  class="badge bg-label-secondary mt-5 mb-5"
                  style="font-size: medium !important;"
                  >{{ profile.online_accounts }}</span
                >
              </div>
              <div
                class="col-md text-center  flex flex-col justify-between align-items-center"
              >
                <div class="card-header pb-0">
                  {{ $t("bandwidth.online_peak_band") }}
                </div>
                <span
                  class="badge bg-label-secondary mt-5 mb-5"
                  style="font-size: medium !important;"
                  >{{
                    formatSpeed(
                      profile.online_accounts *
                        profile.download_rate_kb *
                        (profile.use_percent / 100),
                    )
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div
                class="d-flex align-items-center justify-content-center flex-column flex-md-row pe-5 gap-2 gap-md-4 "
              >
                <button
                  type="button"
                  @click.prevent="
                    total_use_percent = 100;
                    updateAll();
                  "
                  class="btn btn-lg btn-secondary"
                >
                  <span class="ti-xs ti ti-restore me-2"></span
                  >{{ $t("bandwidth.reset") }}
                </button>
                <button
                  @click.prevent="store()"
                  type="button"
                  class="btn btn-lg btn-primary"
                >
                  <span class="ti-xs ti ti-progress-check me-2"></span
                  >{{ $t("bandwidth.update") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { hasPrivilege } from "../global_constants.js";
import { mapGetters } from "vuex";
export default {
  name: "Bandwidth",
  data() {
    return {
      loading: false,
      profiles: [],
      total_use_percent: 100,
    };
  },
  computed: {
    ...mapGetters(["settings", "user"]),
    total_peak() {
      var sum = 0;
      this.profiles.forEach((profile) => {
        sum +=
          profile.online_accounts *
          profile.download_rate_kb *
          (profile.use_percent / 100);
      });
      return sum;
    },
  },
  async created() {
    await this.fetchProfiles();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async store() {
      this.loading = true;
      const response = await axios.post("profiles/bandwidth", {
        profiles: this.profiles,
      });
      if (response.status == 200) {
        this.loading = false;
        this.$router.push({
          path: "/bandwidth",
          query: { success: "success" },
        });
      }
      this.loading = false;
    },
    async fetchProfiles() {
      this.loading = true;
      const response = await axios.get("profiles?rows=10000&online_accounts=1");
      if (response.status == 200) {
        this.profiles = response.data.data;
      }
      var flag = true;
      var val1 = this.profiles[0].use_percent;
      for (let index = 0; index < this.profiles.length; index++) {
        const profile = this.profiles[index];
        if (profile.use_percent != val1) {
          flag = false;
          break;
        }
      }
      if (flag) this.total_use_percent = val1;
      this.loading = false;
    },
    formatSpeed(speed) {
      if (speed < 0) return "∞";
      if (speed > 1023 && speed < 1000000)
        return parseFloat(speed / 1024).toFixed(2) + " Mb/s";
      else if (speed >= 1000000)
        return parseFloat(speed / 1000000).toFixed(2) + " Gb/s";
      else return parseFloat(speed).toFixed(2) + " Kb/s";
    },
    updateAll() {
      this.profiles.forEach((profile) => {
        profile.use_percent = this.total_use_percent;
      });
    },
    validate() {
      if (this.total_use_percent < 10) this.total_use_percent = 10;
      this.profiles.forEach((profile) => {
        if (profile.use_percent < 10) profile.use_percent = 10;
      });
    },
  },
};
</script>
<style scoped>
input[type="range"]::-webkit-slider-thumb {
  height: 24px;
  width: 24px;
  border-radius: 15px;
  background: #0d4f86;
  cursor: pointer;
  -webkit-appearance: none;
}
</style>
